<template>
  <Form ref="form" @submit="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">{{ formTitle }} documentación digitalizada</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title">Información</h3>
        </div>
        <div class="row card-body">
          <div class="form-group col-sm-12">
            <label for="branchOfficeName">Matriz y/o Sucursales:</label>
            <Field v-model="branchOfficeName" type="text" class="form-control" name="branchOfficeName" disabled />
          </div>

          <div class="form-group col-sm-12">
            <label for="ProspectFullname">Prospecto:</label>
            <Field v-model="prospectusFullName" type="text" class="form-control" name="ProspectFullname" disabled />
          </div>

          <div class="form-group col-sm-12">
            <label for="loanApplicationReferenceNumber">Solicitud:</label>
            <Field v-model="loanApplicationReferenceNumber" type="text" class="form-control" name="loanApplicationReferenceNumber" disabled />
          </div>

          <div class="form-group col-sm-12">
            <label for="recordTypeName">Tipos de expendiente:</label>
            <Field v-model="recordTypeName" type="text" class="form-control" name="recordTypeName" disabled />
          </div>
          <div class="form-group col-sm-6">
            <label for="financialRecordReferenceNumber">Folio de Expediente:</label>
            <Field v-model="financialRecordReferenceNumber" type="text" class="form-control" name="financialRecordReferenceNumber" disabled />
          </div>
          <div class="form-group col-sm-6">
            <label for="financialRecordName">Nombre de Expediente:</label>
            <Field v-model="financialRecordName" type="text" class="form-control" name="financialRecordName" disabled />
          </div>
          <div class="form-group col-sm-12">
            <Field name="completed" v-slot="{ field }">
                <label>
                     <input type="checkbox" name="completed" v-bind="field" :checked="isCompleted" :disabled="isCompletedDisabled()"
                  @change="handleCompletedChange($event)" />
                    Marcar este Checklist como completado
                </label>
            </Field>
          </div>
        </div>
      </div>

      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title">Documentación</h3>
        </div>
        <div class="card-body">
          <div class="row" v-if="getActiveChecklists">
            <div class="info-box col-12 col-sm-12" v-for="(element, idx) in normalizedChecklists" :key="idx">
              <div class="form-group col-sm-6" v-if="element.file">
                <label>Descargar archivo:</label>
                <p><a :href="element.file.filePath" target="_blank">{{ element.file.name
                    }}</a></p>
              </div>
              <div class="form-group" :class="[element.file ? 'col-sm-6' : 'col-sm-12']">
                <label :for="'exampleInputFile' + idx">
                  {{ element.document.documentName }}
                  {{ (element.remarks) ? ` (${element.remarks})` : '' }}:
                </label>
                <span v-if="element.isRequired" style="color: red;"> *</span>
                <div class="input-group">
                  <Field :name="'file-' + idx" type="file" :accept="allowedFileTypes" :id="'exampleInputFile' + idx" ref="fileInputs" @change="handleFileChange($event,idx, element)"></Field>
                  <ErrorMessage :name="'file-' + idx" class="input-error"></ErrorMessage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-between">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">
        {{ cancelButtonText }}
      </button>
      <PrimaryButton class="btn btn-primary" type="submit">
        {{ updateButtonText }}
      </PrimaryButton>
    </div>
  </Form>
</template>

<script>
import * as helper from '@/helpers';
import { mapState, mapActions } from "pinia";
import { financialRecordsStore } from "@/pinia/financialRecords.module";
import { checklistsStore } from '@/pinia/checklists.module';
import { useFlowStatusStore } from '@/pinia/flowStatusStore.module';
import { useIndividualLoanApplicationStore } from '@/pinia/LoanApplications/individual.module';
import { sharedStore } from "@/pinia/sharedStore.module";

import BranchOfficesSelect from "@/Components/Selects/SelectField.vue";
import RecordTypesSelect from "@/Components/Selects/SelectField.vue";
import StatusSelect from "@/Components/Selects/SelectField.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";

import FinancialRecord from '@/Models/FinancialRecord';
import RecordsProspects from '@/Models/RecordsProspects';
import RecordFileForm from '@/Models/RecordFileForm';

import Swal from 'sweetalert2';
import { useToast } from 'vue-toast-notification';

export default {
  components: {
    PrimaryButton,
    StatusSelect,
    BranchOfficesSelect,
    RecordTypesSelect,
  },
  mixins: [],
  data() {
    return {
      dataValues: {},
      recordProspectus: new RecordsProspects({}),
      recordFileFormDto: new RecordFileForm({}),
      selectedBranchOfficeId: null,
      selectedRecordTypeId: null,
      selectedFinancialRecord: new FinancialRecord({}),
      files: {},
      documentIds: [],
      fileInputs: [],
      isCompleted: false,
      recordExists: false,
      allowedFileTypes: ".jpg, .jpeg, .png, .gif, .pdf",
      branchOfficeName: '',
      prospectusFullName: '',
      loanApplicationReferenceNumber: '',
      recordTypeName: '',
      financialRecordReferenceNumber: '',
      financialRecordName: '',
    }
  },
  emits: ['close-modal'],
  props: {
    selectedItem: {
      type: Object,
      default: () => new RecordsProspects({}),
    },
    getProspectusFullname: {
      type: Function,
      default: () => '',
    }
  },
  computed: {
    ...mapState(checklistsStore, ['getActiveChecklists']),
    ...mapState(useFlowStatusStore, ['getFlowStatusByRole', 'getFlowStatus']),
    ...mapState(sharedStore, ['getLoanApplication']),
    formTitle() {
      return this.$getLocaleMessage('formTitles', 'update');
    },
    cancelButtonText() {
      return this.$getLocaleMessage('buttons', 'cancel');
    },
    updateButtonText() {
      return this.$getLocaleMessage('buttons', 'update');
    },
    normalizedChecklists() {
      if (!this.getActiveChecklists) return [];

      return this.getActiveChecklists.map(item => {
        const file = item.file;

        const isFakeFile =
          file &&
          file.name &&
          file.name.toLowerCase().includes('documento-ficticio-4zm0ywce.pdf');

        return {
          ...item,
          file: isFakeFile ? null : file
        };
      });
    }
  },
  methods: {
    ...mapActions(financialRecordsStore, ['updateDocumentFile']),
    ...mapActions(checklistsStore, ['fetchActiveChecklistsWithFilesByRecordId']),
    ...mapActions(useFlowStatusStore, ['fetchFlowStatusByLoanApplicationId', 'saveFlowStatus']),
    ...mapActions(useIndividualLoanApplicationStore, ["fetchIndividualLoanApplicationsByProspectusId"]),
    ...mapActions(sharedStore, ["setSelectedLoanApplication"]),
    areRequiredDocumentsComplete() {
      if (!this.getActiveChecklists) return false;

      return this.getActiveChecklists
        .filter(doc => doc.isRequired)
        .every(doc => {
          const hasRealFile =
            doc.file &&
            !this.isFakeFile(doc.file);

          return hasRealFile;
        });
    },
    async validateChecklistDocCompletion() {
      let missingDocuments = [];

      this.getActiveChecklists.forEach((doc, index) => {
        if (doc.isRequired) {
          const newFile = this.files[index];
          const existingFile =
            doc.file && !this.isFakeFile(doc.file)
              ? doc.file
              : null;

          // Si no hay archivo nuevo NI archivo ya guardado
          if (!newFile && !existingFile) {
            missingDocuments.push(doc.document.documentName);
          }
        }
      });

      if (missingDocuments.length > 0) {
        this.isCompleted = false;
        
        Swal.fire({
          title: 'Faltan documentos requeridos',
          html: `
            Debe cargar todos los documentos requeridos antes de marcar este checklist como completado.<br> 
            ${missingDocuments.join("<br>")}`,
          icon: 'warning',
          confirmButtonText: 'Entendido'
        });

        return false;
      }

      return true;
    },
    async evaluateCompleted(flowStatus) {
      if (!flowStatus) return;

      const allDocsComplete = this.areRequiredDocumentsComplete();

      // 🟢 OPERATIVO
      if (this.selectedItem.financialRecord.recordTypeId === 1) {
        if (!this.selectedItem?.loanApplication?.prospectusId) return;

        // 1️⃣ Cargar loan applications
        await this.fetchIndividualLoanApplicationsByProspectusId(
          this.selectedItem.loanApplication.prospectusId
        );

        // 2️⃣ Seleccionar loan correcto
        this.setSelectedLoanApplication(
          this.selectedItem.loanApplicationId
        );

        const dataConsultFlow = {
          operational: flowStatus !== null ? flowStatus.operational : false
        };

        this.isCompleted = dataConsultFlow.operational && allDocsComplete;
      }

      // 🔵 LEGAL
      else if (this.selectedItem.financialRecord.recordTypeId === 2) {
        this.isCompleted = flowStatus.legal && allDocsComplete;
      }

      // 🟡 AML / PLD
      else if (this.selectedItem.financialRecord.recordTypeId === 3) {
        this.isCompleted = flowStatus.aml && allDocsComplete;
      }
    },
    async handleCompletedChange(event) {
      var showMSN = false;
      const checked = event.target.checked;
      const allDocsComplete = await this.validateChecklistDocCompletion();

      /*
      ==========================================
      VALIDACIÓN POR TIPO DE EXPEDIENTE
      ==========================================
      */

      // 🟢 OPERATIVO
      if (this.selectedItem.financialRecord.recordTypeId === 1) {
        if (!this.selectedItem?.loanApplication?.prospectusId) return;

        // 1️⃣ Cargar loan applications
        await this.fetchIndividualLoanApplicationsByProspectusId(
          this.selectedItem.loanApplication.prospectusId
        );

        // 2️⃣ Seleccionar loan correcto
        this.setSelectedLoanApplication(
          this.selectedItem.loanApplicationId
        );

        if (await this.getLoanApplication.creditScore === null) {
          showMSN = true;
        }

        if (showMSN) {

          this.isCompleted = false;
          event.target.checked = false;

          Swal.fire({
            title: 'No se puede completar',
            html:
              `
            El expediente operativo aún no está autorizado.<br>
            El proceso de calificaciones no ha sido configurado.<br>
            Es necesario completar esta sección antes de marcar este checklist como completado.
          `,
            icon: 'warning',
            confirmButtonText: 'Entendido'
          });

          return;
        }
      }

      /*
      ==========================================
      OTROS TIPOS (LEGAL, PLD, ETC)
      ==========================================
      */

      if (!allDocsComplete) {
        this.isCompleted = false;
        event.target.checked = false;
        return;
      }

      this.isCompleted = checked;
      return;
    },
    isCompletedDisabled() {
      const flowStatus = this.getFlowStatus;
      const allDocsComplete = this.areRequiredDocumentsComplete();

      if (this.selectedItem.financialRecord.recordTypeId === 3) {
        return flowStatus?.aml;
      }

      if (this.selectedItem.financialRecord.recordTypeId === 2) {
        return flowStatus?.legal;
      }

      if (this.selectedItem.financialRecord.recordTypeId === 1) {
        return flowStatus?.operational;
      }

      return allDocsComplete;
    },
    async onSubmit() {
      var dataFlow = null;
      const formData = new FormData();
      // Add files to the FormData
      formData.append('documentFileDto.loanApplicationId', this.selectedItem.loanApplicationId);
      formData.append('documentFileDto.FinancialRecordId', this.selectedItem.financialRecordId);
      formData.append('documentFileDto.RecordTypeId', this.selectedItem.financialRecord.recordTypeId);
      formData.append('documentFileDto.IsCompleted', this.isCompleted);

      Object.values(this.documentIds).forEach((item, index) => {
        formData.append(`documentFileDto.DocumentIds[${index}]`, item);
      });

      Object.values(this.files).forEach((file, index) => {
        formData.append(`documentFileDto.Files`, file);
      });

      if (this.selectedItem.financialRecord.recordTypeId === 1) {
        if (this.getFlowStatus === null) {
          dataFlow = {
            loanApplicationId: this.selectedItem.loanApplicationId,
            operational: this.isCompleted
          }
        } else {
          dataFlow = {
            aml: this.getFlowStatus.aml,
            legal: this.getFlowStatus.legal,
            loanApplicationId: this.getFlowStatus.loanApplicationId,
            operational: this.isCompleted
          }
        }
      }

      if (this.selectedItem.financialRecord.recordTypeId === 2) {
        if (this.getFlowStatus === null) {
          dataFlow = {
            loanApplicationId: this.selectedItem.loanApplicationId,
            legal: this.isCompleted
          }
        } else {
          dataFlow = {
            aml: this.getFlowStatus.aml,
            legal: this.isCompleted,
            loanApplicationId: this.getFlowStatus.loanApplicationId,
            operational: this.getFlowStatus.operational
          }
        }
      }

      if (this.selectedItem.financialRecord.recordTypeId === 3) {
        if (this.getFlowStatus === null) {
          dataFlow = {
            loanApplicationId: this.selectedItem.loanApplicationId,
            aml: this.isCompleted
          }
        } else {
          dataFlow = {
            aml: this.isCompleted,
            legal: this.getFlowStatus.legal,
            loanApplicationId: this.getFlowStatus.loanApplicationId,
            operational: this.getFlowStatus.operational
          }
        }
      }

      const hasFiles = Object.values(this.files).length > 0;

      if (hasFiles) {
        await this.updateDocumentFile(formData);
      }

      await this.saveFlowStatus(dataFlow);
      this.$refs.form.resetForm();
      this.closeModal();
    },
    closeModal() {
      this.$emit("close-modal", true);
    },
    async handleFileChange(event, index, currentElement) {
      const fileId = currentElement.documentId;
      const fileInput = event.target;

      if (fileInput.files.length > 0) {
        // ✅ Agregar archivo
        this.documentIds[index] = fileId;
        this.files[index] = fileInput.files[0];
      } else {
        // ✅ Eliminar archivo
        delete this.files[index];
        delete this.documentIds[index];

        // ✅ Si el documento es requerido
        // y ya no existe archivo guardado ni nuevo
        if (
          currentElement.isRequired &&
          !currentElement.file
        ) {
          this.isCompleted = false;
        }
      }
    },
    validateDocument(element) {
      return (element.isRequired && element.file == null) ? 'required': undefined;
    },
    isFakeFile(file) {
      return (
        file &&
        file.name &&
        file.name.toLowerCase() === 'documento-ficticio-4zm0ywce.pdf'
      );
    }
  },
  watch: {
    'getFlowStatusByRole': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.isCompleted = newValue;
        }
      }
    },
    'getFlowStatus': {
      immediate: true,
      handler(flowStatus) {
        this.evaluateCompleted(flowStatus);
      }
    },
    getActiveChecklists: {
      immediate: true,
      deep: true,
      handler() {
        this.evaluateCompleted(this.getFlowStatus);
      }
    }
  },
  async created() {
    const validateProperties = ["loanApplicationId", "financialRecordId", "documentId", "fileId", "loanApplication", "financialRecord"];
    if (helper.validateObjectProperties(this.selectedItem, validateProperties)) {
      this.branchOfficeName = (this.selectedItem?.loanApplication?.prospectus?.branchOffice?.id ? `${this.selectedItem.loanApplication.prospectus.branchOffice.name } ` : null);
      this.loanApplicationReferenceNumber = (this.selectedItem?.loanApplication.referenceNumber ? this.selectedItem.loanApplication.referenceNumber : null);
      this.recordTypeName = (this.selectedItem?.financialRecord?.recordType?.name ? this.selectedItem.financialRecord.recordType.name : null);
      this.financialRecordReferenceNumber = (this.selectedItem?.financialRecord?.referenceNumber ? this.selectedItem.financialRecord.referenceNumber : null);
      this.financialRecordName = (this.selectedItem?.financialRecord?.name ? this.selectedItem.financialRecord.name : null);
      this.prospectusFullName = (this.selectedItem?.loanApplication?.prospectus?.prospectusId) ? this.getProspectusFullname(this.selectedItem.loanApplication.prospectus) : null;
      await this.fetchActiveChecklistsWithFilesByRecordId(this.selectedItem.financialRecordId, this.selectedItem.loanApplicationId);
      // Make a request to get isCompleted value from FlowStatus table
      await this.fetchFlowStatusByLoanApplicationId(this.selectedItem.loanApplicationId);
    }
  },
  mounted() {
  },
};
</script>